import { render, staticRenderFns } from "./ChartPedidos.vue?vue&type=template&id=277c3c8a"
import script from "./ChartPedidos.vue?vue&type=script&lang=js"
export * from "./ChartPedidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports